import http from "@/http-common";

/**
 * Service quản lý gán khoản thu (Revenue Scope)
 * Base URL: /web/revenue-scope
 * Lưu ý: idSchool KHÔNG cần truyền – BE tự xác định qua JWT token.
 */
class RevenueScopeService {
  /**
   * Lấy danh sách đối tượng (Lớp/Nhóm/Gói) đã được gán ít nhất 1 khoản thu
   * @param {Object} params - { targetType, page, size }
   * targetType: 'CLASS' | 'GROUP' | 'PACKAGE'
   */
  getTargets(params) {
    return http.get("/revenue-scope/targets", { params });
  }

  /**
   * Lấy toàn bộ khoản thu của trường kèm trạng thái đã gán cho đối tượng
   * @param {Object} params - { targetId, targetType }
   * targetId: Long (ID của Lớp/Nhóm/Gói)
   * targetType: 'CLASS' | 'GROUP' | 'PACKAGE'
   */
  getDetails(params) {
    return http.get("/revenue-scope/details", { params });
  }

  getRevenueScopeRegisterDetails(params) {
    return http.get("/revenue-scope/details/register", { params });
  }

  /**
   * Đồng bộ (replace-all) danh sách khoản thu cho đối tượng
   * @param {Object} data - { targetId, targetType, idTotalRevenues }
   * idTotalRevenues: String[] (UUID list) – null hoặc [] sẽ xóa toàn bộ
   */
  register(data) {
    return http.post("/revenue-scope/register", data);
  }
}

export default new RevenueScopeService();

